import React from "react";
import { useNavigate } from "react-router-dom";

const TermsAndConditions2 = () => {
  const navigate = useNavigate();
  return (
    <div className="tpu__splashScreen__wrapper layoutContainer"
    style={{
        padding: "2rem"
    }}
    >
      {/* Back navigation */}
      <div style={{ marginBottom: "12px" }}>
        <button
          onClick={() => navigate("/")}
          style={{
            background: "rgba(0, 0, 0, 0.05)",
            border: "none",
            borderRadius: "6px",
            padding: "6px 12px",
            color: "#3797F0",
            fontSize: "13px",
            fontWeight: "600",
            cursor: "pointer",
          }}
        >
          ← Back to Home
        </button>
      </div>

      <h2 style={styles.header}>Terms and Conditions – Task Planet</h2>
      <p style={styles.date}>Last Updated: 18 Aug 2025</p>
      <a href="https://www.taskplanet.org" target="_blank" rel="noreferrer" style={styles.link}>
        Website: www.taskplanet.org
      </a>
      <p style={styles.paragraph}>
        Welcome to Task Planet! These Terms and Conditions (“Terms”) govern your
        use of our website and services. By accessing or using Task Planet, you
        agree to comply with and be bound by these Terms. If you do not agree,
        please stop using our platform.
      </p>

      <Section
        title="1. Indian Users"
        items={[
          "Indian users can access and use Task Planet to create, manage, and participate in tasks or services available on the platform.",
          "Payments are supported for Indian users.",
          "Users must provide accurate details for account creation and transactions.",
        ]}
      />

      <Section
        title="2. Global Users"
        items={[
          "Task Planet is available to users worldwide.",
          "Payments are supported for international users.",
          "Global users agree to follow the same rules and responsibilities as Indian users.",
        ]}
      />

      <Section
        title="3. Accounts and Access"
        items={[
          "Each individual is allowed to maintain only one account.",
          "Creating multiple accounts using the same identity, email, or other personal details is strictly prohibited.",
          "If multiple accounts are found linked to the same person, all such accounts may be permanently blocked.",
          "You are responsible for keeping your login details safe and secure.",
        ]}
      />

      <Section
        title="4. User Responsibilities"
        content="You agree not to:"
        items={[
          "Use Task Planet for unlawful, harmful, or fraudulent purposes.",
          "Post content that is defamatory, offensive, obscene, or violates intellectual property rights.",
          "Attempt to hack, disrupt, or misuse our systems or other users’ accounts.",
          "Create multiple accounts under the same identity (see Section 3).",
        ]}
      />

      <Section
        title="5. Intellectual Property"
        items={[
          "All content, trademarks, and materials on Task Planet belong to Task Planet and/or its licensors.",
          "You may use the platform only for personal, non-commercial purposes.",
          "You may not copy, resell, or redistribute any material without written permission.",
        ]}
      />

      <Section
        title="6. User-Generated Content"
        items={[
          "Users may post comments, feedback, or other content on the platform.",
          "By posting content, you grant Task Planet a non-exclusive, worldwide license to use, display, and distribute such content.",
          "Task Planet reserves the right to remove any content that is inappropriate or violates these Terms.",
        ]}
      />

      <Section
        title="7. Privacy"
        items={[
          "Your use of the platform is governed by our Privacy Policy, which explains how we collect, use, and protect your data.",
          "By using Task Planet, you consent to the data practices described in our Privacy Policy.",
        ]}
      />

      <Section
        title="8. Limitation of Liability"
        content="Task Planet provides its services on an “as is” and “as available” basis. We are not responsible for:"
        items={[
          "The quality, accuracy, or outcomes of tasks or services exchanged between users.",
          "Delays, disputes, or losses arising from user interactions.",
          "Third-party links, services, or payment providers.",
          "To the maximum extent permitted by law, Task Planet shall not be liable for any indirect, incidental, or consequential damages.",
        ]}
      />

      <Section
        title="9. Termination"
        items={[
          "Task Planet may suspend or terminate your account if you violate these Terms.",
          "If multiple accounts are detected under one identity, all related accounts may be blocked permanently.",
          "You may stop using our platform at any time.",
        ]}
      />

      <Section
        title="10. Changes to These Terms"
        items={[
          "We may update these Terms from time to time. Updates will be posted on this page with the revised “Effective Date.”",
          "Continuing to use Task Planet after updates means you agree to the new Terms.",
        ]}
      />

      <SimpleSection
        title="11. Contact Us"
        text="For any questions about these Terms, please contact: support@taskplanet.org"
      />
    </div>
  );
};

const Section = ({ title, content, items }) => (
  <div style={styles.section}>
    <h3 style={styles.sectionTitle}>{title}</h3>
    {content && <p style={styles.sectionContent}>{content}</p>}
    <ul style={styles.list}>
      {items?.map((item, i) => (
        <li key={i} style={styles.listItem}>{item}</li>
      ))}
    </ul>
  </div>
);

const SimpleSection = ({ title, text }) => {
  const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;
  const emailMatch = text.match(emailRegex);

  return (
    <div style={styles.section}>
      <h3 style={styles.sectionTitle}>{title}</h3>
      {emailMatch ? (
        <p style={styles.sectionContent}>
          {text.split(emailMatch[0])[0]}
          <a href={`mailto:${emailMatch[0]}`} style={styles.email}>
            {emailMatch[0]}
          </a>
          {text.split(emailMatch[0])[1]}
        </p>
      ) : (
        <p style={styles.sectionContent}>{text}</p>
      )}
    </div>
  );
};

const styles = {
  container: { maxWidth: "800px", margin: "0 auto", padding: "20px", fontFamily: "Arial, sans-serif", backgroundColor: "#fff" },
  header: { fontSize: "22px", fontWeight: "bold", marginBottom: "10px", color: "#333" },
  date: { fontSize: "14px", color: "#555", marginBottom: "8px" },
  link: { fontSize: "14px", color: "blue", marginBottom: "16px", display: "block", textDecoration: "underline" },
  paragraph: { fontSize: "14px", lineHeight: "22px", color: "#444", marginBottom: "16px" },
  section: { marginBottom: "20px" },
  sectionTitle: { fontSize: "16px", fontWeight: "bold", marginBottom: "8px", color: "#222" },
  sectionContent: { fontSize: "14px", color: "#555", marginBottom: "10px", lineHeight: "22px" },
  listItem: { fontSize: "14px", color: "#444", marginBottom: "6px" },
  email: { color: "blue", textDecoration: "underline" },
  list:{
    listStyle: "none"
  }
};

export default TermsAndConditions2;
